<template>
  <div class="display p-4 bg-dark text-white position-relative d-flex flex-column align-items-center justify-content-center" :class="{ 'min-h-100': !sender, 'h-100': sender }">
    <div class="toolbar bg-dark d-flex shadow align-items-center" :class="{ 'position-fixed': !sender, 'position-absolute': sender }">
      <div class="mr-2">Text size</div>
      <div class="text-size-selector">
        <div class="btn-group">
          <button type="button" class="btn btn-lg btn-outline-secondary" @click="decreaseFontSize()" :disabled="timerFontSize == 0">-</button>
          <button type="button" class="btn btn-lg btn-outline-secondary" @click="increaseFontSize()">+</button>
        </div>
      </div>

      <div class="clock text-right ml-auto" v-if="timer.showTimer">
        {{ clock }}
      </div>
    </div>

    <div class="d-flex flex-column h-100" style="padding-top: 120px;" :style="{ 'font-size': currentFontSize }">
      <div class="flex-fill d-flex">
        <vue-countdown ref="vueCountdown" :time="timerText" :auto-start="timer.started" :transform="transform" v-if="timer && timer.showTimer">
          <template slot-scope="props">{{ props.hours }}:{{ props.minutes }}:{{ props.seconds }}</template>
        </vue-countdown>

        <div v-if="timer && !timer.showTimer">
          {{ clock }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { firebase } from "@/initializers/firebase"

  import VueCountdown from '@chenfengyuan/vue-countdown';
  
  export default {
    name: "display",
    components: { VueCountdown },
    props: {
      sender: {
        type: Boolean,
        default: false
      }
    },
    data() {
      return {
        timer: null,
        now: this.$DateTime.local(),
        clockInterval: null,
        timerFontSize: 2
      }
    },
    computed: {
      clock() {
        return this.now.toFormat("HH:mm:ss")
      },
      timerText() {
        if (this.timer && this.timer.time) {
          let [hours, minutes, seconds] = this.timer.time.split(":")
          return (hours * 60 * 60 + minutes * 60 + +seconds) * 1000
        } else {
          return 0
        }
      },
      currentFontSize() {
        if(this.timerFontSize) {
          return `${this.timerFontSize}rem`
        } else {
          return `2rem`
        }
      }
    },
    methods: {
      startClock() {
        this.clockInterval = setInterval(this.runClock, 1000)
      },
      runClock() {
        this.now = this.$DateTime.local()
      },
      initLocalStorage() {
        const storage = window.localStorage.getItem("jaws-nanocom-app")
        if(!storage) {
          window.localStorage.setItem("jaws-nanocom-app", JSON.stringify({}))
        }
      },
      setFontSize() {
        const storage = window.localStorage.getItem("jaws-nanocom-app")
        const lsData = JSON.parse(storage)

        if(lsData.timerFontSize) {
          this.timerFontSize = parseInt(lsData.timerFontSize)
        } else {
          this.timerFontSize = 2
        }
      },
      increaseFontSize() {
        const storage = window.localStorage.getItem("jaws-nanocom-app")
        let lsData = JSON.parse(storage)
        
        let fontSize = (parseInt(this.timerFontSize) + 1)
        lsData.timerFontSize = fontSize

        window.localStorage.setItem("jaws-nanocom-app", JSON.stringify(lsData))

        this.setFontSize()
      },
      decreaseFontSize() {
        const storage = window.localStorage.getItem("jaws-nanocom-app")
        let lsData = JSON.parse(storage)

        let fontSize = (parseInt(this.timerFontSize) - 1)

        if(fontSize > 0) {
          lsData.timerFontSize = fontSize

          window.localStorage.setItem("jaws-nanocom-app", JSON.stringify(lsData))

          this.setFontSize()
        }
      },
      transform(props) {
        Object.entries(props).forEach(([key, value]) => {
          const digits = value < 10 ? `0${value}` : value;
          props[key] = `${digits}`;
        });

        return props;
      },
      startTimer() {
        if (this.$refs.vueCountdown) {
          this.$refs.vueCountdown.start()
        }
      },

      stopTimer() {
        if (this.$refs.vueCountdown) {
          this.$refs.vueCountdown.abort()
        }
      }
    },
    watch: {
      timer: {
        deep: true,
        handler: function(newTimer) {
          if (newTimer.started) {
            this.startTimer()
          } else {
            this.stopTimer()
          }
        }
      }
    },
    async mounted() {
      this.initLocalStorage()
      this.setFontSize()

      clearInterval(this.clockInterval)
      this.startClock()

      let app = await firebase.firestore().collection(`app`)
      await this.$bind("timer", app.doc(`timer`))
    }
  }
</script>

<style scoped lang="scss">
  // .text-size-selector { top: 20px; left: 20px; }
  .toolbar { top: 0; left: 0; right: 0; padding: 20px; }
  .clock { font-size: 3rem; }
  // .clock { top: 20px; right: 20px; }
</style>